// meta-frentista-ia-a7 — convite da Meta de Frentista em dialog (Home)
const catalogo: Record<string, string> = {
    "Leitura da IA · %{inicio} a %{fim}": "Lectura de la IA · %{inicio} a %{fim}",
    "dias grátis": "días gratis",
    "Sem custo e sem cobrança automática. No fim do teste, desliga sozinho.": "Sin costo y sin cobro automático. Al final de la prueba, se desactiva solo.",
    "A IA monta a meta de cada posto": "La IA arma el objetivo de cada estación",
    "Você revisa e ativa com 1 clique": "Usted revisa y activa con 1 clic",
    "Leitura da IA toda semana": "Lectura de la IA cada semana",
};

export default catalogo;
